<template>
    <div>
        <Main title="POI Submissions" subtitle="Overall POI Submissions">
            <template v-slot:buttons>
                <div class="btn-toolbar float-right" role="toolbar" aria-label="Create">
                    <a @click="createNewSubmission()" class="btn btn-success ml-1 text-white" data-toggle="tooltip" title="Create New Submission"><i class="fas fa-plus-circle"></i> Create</a>
                </div><!--btn-toolbar-->
            </template>
            <template v-slot:table>
                <v-app>
                    <div class="row mb-1 justify-content-between">
                        <div class="col-md-4 align-self-center">
                            <div class="input-group">
                                <v-text-field
                                    v-model="search.q"
                                    clearable
                                    clear-icon="mdi-close"
                                    type="text"
                                    placeholder="Search by submission name"
                                >
                                </v-text-field>
                            </div>
                        </div>
                        <div class="col-1 align-self-center">
                            <div class="btn-toolbar float-right" role="toolbar">
                                <button class="btn btn-light" type="button" data-toggle="modal" data-target=".filter-modal"><i class="fas fa-filter"></i></button>
                            </div><!--btn-toolbar-->
                        </div><!--col-->
                    </div>
                    <div class="modal fade filter-modal" tabindex="-1" role="dialog" aria-hidden="true">
                        <div class="modal-dialog modal-lg">
                            <div class="modal-content">
                                <div class="modal-header">
                                    <h5 class="modal-title">Sort Submissions</h5>
                                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                        <span aria-hidden="true">&times;</span>
                                    </button>
                                </div>
                                <div class="modal-body">
                                    <v-row class="mt-2">
                                        <v-col
                                            cols="12"
                                            md="6"
                                        >
                                            <v-select
                                                v-model="search.sortBy"
                                                :items="sorts"
                                                label="Sort By"
                                            ></v-select>
                                        </v-col>
                                        <v-col
                                            cols="12"
                                            md="6"
                                        >
                                            <v-select
                                                v-model="search.orderBy"
                                                :items="orders"
                                                label="Order By"
                                            ></v-select>
                                        </v-col>
                                    </v-row>
                                </div>
                                <div class="modal-footer">
                                    <div class="col-md-2 col-2 px-0 text-right">
                                        <v-progress-circular
                                            v-if="search.loading"
                                            :width="2"
                                            :size="30"
                                            indeterminate
                                            color="#fb7e42"
                                            class="mr-2"
                                        ></v-progress-circular>

                                        <button type="button" class="btn btn-light" data-dismiss="modal" aria-label="Close">
                                            <span aria-hidden="true">Close</span>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <TableLoading cols="10" v-if="loading"></TableLoading>
                    <div class="table-responsive mt-4" v-if="!loading">
                        <table class="table">
                            <thead>
                            <tr>
                                <th>
                                    <v-tooltip top>
                                        <template v-slot:activator="{ on }">
                                            <span v-on="on">ID</span>
                                        </template>
                                        <span>Submission Identifier</span>
                                    </v-tooltip>
                                </th>
                                <th>
                                    <v-tooltip top>
                                        <template v-slot:activator="{ on }">
                                            <span v-on="on">Name</span>
                                        </template>
                                        <span>Submission Name</span>
                                    </v-tooltip>
                                </th>
                                <th>
                                    <v-tooltip top>
                                        <template v-slot:activator="{ on }">
                                            <span v-on="on">POIs</span>
                                        </template>
                                        <span>Total POIs in this submission</span>
                                    </v-tooltip>
                                </th>
                                <th>
                                    <v-tooltip top>
                                        <template v-slot:activator="{ on }">
                                            <span v-on="on">Brand</span>
                                        </template>
                                        <span>Submission Brand</span>
                                    </v-tooltip>
                                </th>
                                <th>
                                    <v-tooltip top>
                                        <template v-slot:activator="{ on }">
                                            <span v-on="on">Status</span>
                                        </template>
                                        <span>Submission Status</span>
                                    </v-tooltip>
                                </th>
                                <th>
                                    <v-tooltip top>
                                        <template v-slot:activator="{ on }">
                                            <span v-on="on">Submitted by</span>
                                        </template>
                                        <span>Submission was created by</span>
                                    </v-tooltip>
                                </th>
                                <th>
                                    <v-tooltip top>
                                        <template v-slot:activator="{ on }">
                                            <span v-on="on">Updated at</span>
                                        </template>
                                        <span>Submission Updated at</span>
                                    </v-tooltip>
                                </th>
                                <th>
                                    <v-tooltip top>
                                        <template v-slot:activator="{ on }">
                                            <span v-on="on">Created at</span>
                                        </template>
                                        <span>Submission Created at</span>
                                    </v-tooltip>
                                </th>
                                <th>
                                    <v-tooltip top>
                                        <template v-slot:activator="{ on }">
                                            <span v-on="on">Actions</span>
                                        </template>
                                        <span>Submission Actions</span>
                                    </v-tooltip>
                                </th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr v-for="submission in submissions" :key="submission.id" class="submission-row">
                                <td>{{ submission.id || '' }}</td>
                                <td>{{ submission.name || '' }}</td>
                                <td>{{ new Intl.NumberFormat().format(submission.pois_imported) || '' }}</td>
                                <td>
                                    <span v-if="submission.brand">{{ submission.brand.name || '' }}</span>
                                    <span v-else>{{ submission.info.brand || '' }}</span>

                                    <v-tooltip top color="success" v-if="submission.info.brand">
                                        <template v-slot:activator="{ on }">
                                            <span v-on="on"><i class="fa fa-plus-circle text-success ml-1"></i></span>
                                        </template>
                                        <span>New Brand Requested</span>
                                    </v-tooltip>
                                </td>
                                <td>
                                    <v-progress-linear
                                        v-if="submission.status === 1"
                                        color="#fb7e42"
                                        height="10"
                                        indeterminate
                                        rounded
                                    ></v-progress-linear>
                                    <v-progress-linear
                                        v-if="submission.status === 2"
                                        color="success"
                                        height="10"
                                        value="100"
                                        rounded
                                    ></v-progress-linear>
                                    <v-progress-linear
                                        v-if="submission.status === 3"
                                        color="error"
                                        height="10"
                                        value="100"
                                        rounded
                                    ></v-progress-linear>
                                    <span>{{ submission.status_string }}</span>
                                </td>
                                <td>{{ submission.user.full_name || '' }}</td>
                                <td>{{ submission.updated_at || '' }}</td>
                                <td>{{ submission.created_at || '' }}</td>
                                <td class="btn-td">
                                    <div class="btn-group" role="group" aria-label="User Actions">
                                        <v-btn
                                            v-if="submission.status != 2"
                                            depressed
                                            color="error"
                                            class="btn btn-danger"
                                            @click="showDeleteModal(submission)"
                                        >
                                            <i class="fas fa-trash"></i>
                                        </v-btn>
                                        <button v-else class="btn btn-danger" disabled><i class="fas fa-trash"></i></button>
                                    </div>
                                </td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                </v-app>
            </template>
        </Main>

        <DeleteModal v-if="deleteModalDialog"></DeleteModal>
        <CreateNewSubmission v-if="showCreateDialog" ref="createSubmissionRef"></CreateNewSubmission>
        <CreateNewBrand v-if="showCreateBrandDialog" @brand-created="fetchBrandsOnCreateBrand"></CreateNewBrand>
    </div>
</template>

<script>
import Main from '../../../components/Main'
import api from "../../../api/my-data/poi/submissions";
import DeleteModal from "../../../components/general/DeleteModal";
import mixins from "../../../mixin";
import TableLoading from "../../../components/general/TableLoading";
import CreateNewSubmission from "../../../components/MyData/Poi/CreateNewSubmission";
import CreateNewBrand from "../../../components/MyData/Poi/CreateNewBrand";

export default {
    name: "PoiSubmissions",
    mixins: [mixins],
    data: () => ({
        filter: false,
        search: {
            q: '',
            sortBy: 'created_at',
            orderBy: 'desc',
            loading: false,
        },
        sorts: [
            {
                value: 'name',
                text: 'Name'
            },
            {
                value: 'status',
                text: 'Status'
            },
            {
                value: 'created_at',
                text: 'Last Created'
            },
            {
                value: 'updated_at',
                text: 'Last Updated'
            },
        ],

        loading: true,
        deleteModalDialog: false,
        submissions: [],
        submission: [],
        showCreateDialog: false,
        showCreateBrandDialog: false,
        deletingSubmission: [],
    }),
    components: {
        CreateNewBrand,
        CreateNewSubmission,
        TableLoading,
        DeleteModal,
        Main,
    },
    methods: {
        showDeleteModal(submission) {
            this.deletingSubmission = submission
            this.deleteModalDialog = true
        },
        fetchBrandsOnCreateBrand(id) {
            this.$refs.createSubmissionRef.fetchBrands()
            this.$refs.createSubmissionRef.brands = id
        },
        async deleteItem() {
            await api.deleteSubmission({
                id: this.deletingSubmission.id,
            })
            .then(res => {
                this.$toast.open({
                    message: res.data.message,
                    type: "success",
                })
                this.deleteModalDialog = false
                this.deletingSubmission = []
                this.fetchData()
            })
            .catch(e => {
                this.$toast.open({
                    message: e.response.data.message,
                    type: "error",
                })
                this.deleteModalDialog = false
                this.deletingSubmission = []
            })
        },
        async fetchData() {
            await api.getAllSubmissions({
                q: this.search.q,
                sortBy: this.search.sortBy,
                orderBy: this.search.orderBy,
            })
            .then(res => {
                this.submissions = res.data
                this.loading = false
            })
            .catch(e => {
                this.$toast.open({
                    message: e.response.data.message,
                    type: "error",
                })
            })
        },
        createNewSubmission() {
            this.showCreateDialog = true
        },
        filterData: _.debounce(function() {
            this.fetchData()
            this.search.loading = false
        }, 800),
    },
    created() {
        this.fetchData()
    },
    watch: {
        '$store.getters.getCompanyId' : function (val) {
            if (val !== null) {
                window.Echo.private('submissions-' + this.$store.getters.getCompanyId)
                    .listen('Backend\\POI\\Submission\\SubmissionUpdated', (e) => {
                        this.fetchData()
                    })
            }
        },
        'search.q': function () {
            if (this.search.q == null) {
                this.search.q = ""
            }
            this.filterData()
        },
        'search.sortBy': function () {
            this.search.loading = true
            this.filterData()
        },
        'search.orderBy': function () {
            this.search.loading = true
            this.filterData()
        },
    },
    mounted() {
        this.$store.dispatch('loadUserCompanyTierInfo')
    }
}
</script>

<style scoped lang="scss">
::v-deep .v-application--wrap {
        min-height: fit-content;
    }

button:focus {
    outline:0;
}

.btn-info {
    border-radius: 5px 0px 0px 5px;
}

.info-data {
    border: 2px solid #fb7e42;
    border-radius: 5px;
    color: #fb7e42;
    font-size: 1.25rem;
    font-weight: bold;
}

.info-label {
    color: #fb7e42;
}

</style>